import { debounce } from 'lodash';

import TimePicker from 'components/shared/TimePicker/TimePicker';

const TransactionBatchTime = ({ practice, updatePractice, debounceTime = 0 }) => {
  const updateBatchTime = (batch_time) => {
    const updatedDisplaySettings = {
      ...practice.display_settings,
      billing: {
        ...(practice.display_settings?.billing || {}),
        payment: {
          ...(practice.display_settings?.billing?.payment || {}),
          batch_time
        }
      }
    };

    updatePractice({ ...practice, display_settings: updatedDisplaySettings });
  };

  const handleChangeTime = debounce(updateBatchTime, debounceTime);

  return (
    <TimePicker
      isOptions={false}
      value={practice?.display_settings?.billing?.payment?.batch_time}
      onChange={handleChangeTime}
    />
  );
};

export default TransactionBatchTime;
